import angular from 'angular'

import { isFunction } from 'lodash-es'

angular
  .module('ggs.utils')
  .factory('Watchdog', WatchdogProvider)

const TIMEOUT_SKIP_APPLY = false

function WatchdogProvider($q, $timeout, qh) {
  return function Watchdog(allottedTime, action, onTimeEnd, $args) {
    let wait = true
    const deferred = $q.defer()
    const timeoutId = $timeout(onTimeout, allottedTime, TIMEOUT_SKIP_APPLY)
    const target = isFunction(action) ? qh.try(action, $args) : action
    target.then(onResolve, onReject)
    return deferred.promise

    function onTimeout() {
      if (wait) {
        wait = false
        clear()
        deferred.resolve(qh.try(onTimeEnd, [new Error(`Watchdog: allotted time (${allottedTime}ms) is expired!`)]))
      }
    }

    function onResolve(res) {
      if (wait) {
        wait = false
        clear()
        deferred.resolve(res)
      }
    }

    function onReject(err) {
      if (wait) {
        wait = false
        clear()
        deferred.reject(err)
      }
    }

    function clear() {
      $timeout.cancel(timeoutId)
    }
  }
}
